import { createContext } from "react";

export type Settings = {
  theme: string;
  fontSize: string;
};

const SettingsContext = createContext<Settings>({
  theme: window.matchMedia("(prefers-color-scheme:dark)").matches
    ? "dark"
    : "light",
  fontSize: "small",
});

export { SettingsContext };
